import React from 'react';
import { Form, Input, Button, Icon } from 'antd';
import { SplitAccountModel } from '../../../../models/split_account';

let SplitForm = (props) => {
    const { form, splitAccount } = props;
    const { getFieldDecorator } = form;
    const validations = SplitAccountModel.validations;

    const onSubmit = (e) => {
        e.preventDefault();
        form.validateFields((err, values) => {
			if (err) return;
            props.onSubmit(form.getFieldsValue());
        });
    };

    return (
        <Form onSubmit={onSubmit}>
            {getFieldDecorator("id", {
                initialValue: splitAccount?.id,
            })(<Input autoComplete='off' hidden />)}

            <Form.Item label="Account Number">
                {getFieldDecorator("account_number", {
                    initialValue: splitAccount?.account_number,
                    rules: validations.account_number
                })(<Input autoComplete='off' prefix={<Icon type="profile" />} />)}
            </Form.Item>

            <Form.Item label="Account IFSC">
                {getFieldDecorator("account_ifsc", {
                    initialValue: splitAccount?.account_ifsc,
                    rules: validations.account_ifsc
                })(<Input onChange={(e) => e.target.value = ("" + e.target.value).toUpperCase()}  autoComplete='off' prefix={<Icon type="bank" />} />)}
            </Form.Item>

            <Form.Item label="Account Holder Name">
                {getFieldDecorator("account_holder_name", {
                    initialValue: splitAccount?.account_holder_name,
                    rules: validations.account_holder_name
                })(<Input autoComplete='off' prefix={<Icon type="bank" />} />)}
            </Form.Item>
            
            <div className="w-100 d-flex justify-content-end mt-4">
                <Button type="primary" htmlType="submit" loading={props.loading}>{props.splitAccount ? "Update" : "Create"}</Button>
            </div>
        </Form>
    )
}

SplitForm = Form.create()(SplitForm);
export { SplitForm };